<template>
  <div>
    <table style="width: 80%">
      <tr>
        <td>
          <table>
            <tr>
              <td>
                <div style="float: left">
                  <h1>{{ translateWords.title }}</h1>
                </div>
              </td>
            </tr>
            <tr>
              <td style="padding: 10px">
                <el-input
                  v-model.number="id"
                  :placeholder="translateWords.inputNum"
                ></el-input>
              </td>
              <td style="padding: 10px">
                <el-input
                  v-model="spmc"
                  :placeholder="translateWords.inputName"
                ></el-input>
              </td>
              <td>
                <el-button type="primary" @click="query">{{
                  translateWords.query
                }}</el-button>
              </td>
              <td>
                <el-button type="primary" @click="OpenPL">{{
                  translateWords.batchInput
                }}</el-button>
              </td>
            </tr>
          </table>
          <div>
            <el-table
              ref="multipleTable"
              :data="tableData"
              style="width: 100%"
              @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column
                prop="Id"
                :label="translateWords.code"
                width="100"
              >
              </el-table-column>
              <el-table-column
                prop="ProductName"
                :label="translateWords.ProductName"
                width="200"
              >
              </el-table-column>
              <el-table-column
                width="200"
                prop="ProductCode"
                :label="translateWords.ProductCode"
              >
              </el-table-column>
              <el-table-column
                width="200"
                prop="ProductType"
                :label="translateWords.ProductType"
              ></el-table-column>
                <el-table-column
                width="1"
                prop="ProductTypeCode" v-if="false"
                :label="translateWords.ProductType"
              ></el-table-column>
            </el-table>
          </div>
        </td>
        <td>
          <div v-if="showpl">
            <PLAddSample
              ref="PLAddSample"
              :PositionIdoptions="guishufangjian"
              :selval="multipleSelection"
            ></PLAddSample>
          </div>
        </td>
      </tr>
      <tr></tr>
      <tr>
        <td>
          <div style="float: left">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="1"
              :page-sizes="[10, 20, 30]"
              :page-size="10"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import PLAddSample from "@/components/PLAddSample";
import { importScript } from "../util/importScript";

export default {
  props: ["guishufangjian"],
  name: "WP",
  components: {
    PLAddSample,
  },
  data() {
    return {
      translateWords: {
        title: "网片信息",
        inputNum: "请输入编号",
        inputName: "请输入商品名称",
        query: "查询",
        batchInput: "批量录入",
        code: "编号",
        ProductName: "产品名称",
        ProductCode: "产品条码",
        ProductType: "产品类别",
        selectData: "请选择网片数据",
      },
      tableData: [],
      spmc: "",
      id: "",
      total: 0,
      currPage: 1,
      pageSize: 10,
      isQuery: false,
      showpl: false,
      multipleSelection: null,
      uid: this.$route.query.uid,
      token: this.$route.query.token,
      lang: this.$route.query.lang,
    };
  },
  created: function () {
    this.getData(this.currPage, this.pageSize);
  },
  mounted() {
    var that = this;
    importScript(this.baseurl, () => {
      that.translateWord();
    });
  },
  methods: {
    translateWord() {
      var that = this;

      if (window.jsT) {
        this.translateWords = {
          title: window.jsT.T(that.translateWords.title),
          inputNum: window.jsT.T(that.translateWords.inputNum),
          inputName: window.jsT.T(that.translateWords.inputName),
          query: window.jsT.T(that.translateWords.query),
          batchInput: window.jsT.T(that.translateWords.batchInput),
          code: window.jsT.T(that.translateWords.code),
          ProductName: window.jsT.T(that.translateWords.ProductName),
          ProductCode: window.jsT.T(that.translateWords.ProductCode),
          ProductType: window.jsT.T(that.translateWords.ProductType),
          selectData: window.jsT.T(that.translateWords.selectData),
        };
        console.log(this.translateWords);
      } else {
        console.log("翻译组件加载失败");
      }
    },
    init() {
      this.multipleSelection = null;
    },
    OpenPL() {
      if (
        this.multipleSelection == null ||
        this.multipleSelection.length == 0
      ) {
        alert(this.translateWords.selectData);
        return;
      }
     
      this.showpl = true;
               this.$nextTick(function() {
      this.$refs.PLAddSample.getsampleinit();
              })
    },
    query() {
      this.isQuery = true;
      this.getData(1, 10);
    },
    init() {
      (this.spmc = ""), (this.id = "");
    },
    handleSelectionChange(val) {
      this.multipleSelection = JSON.stringify(val);
    },
    getData(index, size) {
      var params = new URLSearchParams();
      params.append("pageIndex", index);
      params.append("pageSize", size);
      params.append("cmd", "LoadWP");
      if (this.isQuery) {
        params.append("spmc", this.spmc);
        params.append("id", this.id);
      }
      params.append("env", this.env);
      this.$http.post(this.actionurl, params).then((res) => {
        this.tableData = res.data.Data.list;
        this.total = res.data.Data.total;
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currPage = 1;
      this.getData(this.currPage, this.pageSize);
    },
    handleCurrentChange(val) {
      this.currPage = val;
      this.getData(this.currPage, this.pageSize);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/WP.vue